module.exports = __webpack_public_path__ + "img/genom_26_2.802be39d.png";